module.exports = __webpack_public_path__ + "img/checkmark.b890284a.svg";